// Toggle debugging logs
const isDebug = true;
const baseStyles = [
  "color: #fff",
  "background-color: #2759e1",
  "padding: 2px 8px",
  "border-radius: 4px",
].join(";");
function consoleLog() {
  if (window.console && isDebug === true) {
    console.log("%cNP", baseStyles, ...Array.prototype.slice.call(arguments));
  }
}

/**
 * Sets up the form functionality.
 */
function initForm() {
  consoleLog("initForm");
  
  const listPacks = document.querySelectorAll(".package_col");
  const attrRegPrice = "data-price";
  const attrSubPrice = "data-subscription-price";

  /**
   * Adds an item to the cart.
   *
   * @param {string} variant_id - The Shopify ID of the variant to add to the cart.
   * @param {number} qty - The quantity of the variant to add to the cart.
   * @param {number} selling_plan - The StayAI selling plan ID (optional).
   * @returns {boolean} - Returns false.
   */
  const formATC = (variant_id, qty, selling_plan, listPack) => {
    consoleLog(["formATC", variant_id, qty, selling_plan]);
    data = {
      id: variant_id,
      quantity: qty,
    };
    if (selling_plan > 0) {
      data["selling_plan"] = selling_plan;
    }
    consoleLog(["data", data]);

    // const product = window.product;

    // fbq_data = {
    //   content_name: product.title,
    //   content_ids: product.id,
    //   content_type: "product_group",
    //   value: currentPrice.value,
    //   currency: product.currency,
    // };
    // consoleLog(["fbq_data", fbq_data]);
    // fbq("track", "AddToCart", fbq_data);
    // fbq("track", "InitiateCheckout", fbq_data);

    // make sure iCart is gone
    removeICart();

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        consoleLog('Waiting for iCart...');
        
        setTimeout(function () {
          consoleLog('Trying to get to checkout');
          listPack.querySelector(".package_button").classList.remove("processing");
          window.location.href = "/checkout?skipCache";
        }, 1000);
        return false;
      },
    });
  };

  /**
   * Adds a list pack to the cart.
   *
   * @param {HTMLElement} listPack - The list pack element to be added to the cart.
   */
  const addListPackToCart = (listPack) => {
    const currentVariant = listPack.getAttribute("data-id");

    let stayFrequency = 0;
    const isChecked = listPack.querySelector('input[type="checkbox"]').checked;
    if (isChecked) {
      stayFrequency =
        listPack.querySelector(".rtx-frequency").value ||
        listPack.querySelector(".rtx-frequency").options[0].value;
    }

    formATC(currentVariant, 1, stayFrequency, listPack);
  };

  /**
   * Initializes the Stay AI data by making an AJAX request to retrieve the product information.
   * If the product has selling plan groups and a specific selling plan group with app_id "5859381",
   * it populates the frequency options for the selling plans.
   * If the product does not have selling plan groups or the specific selling plan group is not found,
   * it hides the stay container.
   */
  const initStayAIData = () => {
    consoleLog("initStayAIData");
    const productHandle = window.product.handle;
    $.getJSON(
      `${window.Shopify.routes.root}products/${productHandle}.js`,
      (product) => {
        const staySelligPlan = product.selling_plan_groups.find(
          (plan) => plan.app_id === "5859381"
        );
        if (product.selling_plan_groups.length < 0 && !staySelligPlan) {
          $(".stay-container").hide();
          return;
        }

        const sellingPlans = staySelligPlan.selling_plans;

        const sortedSellingPlans = sellingPlans.sort((a, b) => {
          const bPlanValue = b.options[0].value.toLowerCase();
          const bFrequency = bPlanValue.split(" ")[0];

          const aPlanValue = a.options[0].value.toLowerCase();
          const aFrequency = aPlanValue.split(" ")[0];

          if (aFrequency === bFrequency) return 0;
          return aFrequency < bFrequency ? -1 : 1;
        });

        // update subscription price (as we need exact one for currency purposes rather than calculating)
        product.variants.forEach((variant) => {
          const pack = variant.title.split(" ")[0];
          const listPack = document.querySelector(`.package_col[data-pack="${pack}"]`);

          if (!listPack || !variant?.selling_plan_allocations[0]?.price) return;

          const elRegPrice = listPack.querySelector(`.reg-price-${pack}`);
          const elYouSave = listPack.querySelector(`.you-save-price-${pack}`);
          const elSavePrice = listPack.querySelector(`.save-price-${pack}`);
          
          let comparePrice = elRegPrice.getAttribute(attrRegPrice);
          let subscriptionPrice = variant.selling_plan_allocations[0].price / 100;
          
          let isEu = false;
          if (comparePrice.includes(",")) {
            if (comparePrice.includes(".")) {
              comparePrice = comparePrice.replace(",", "");
            } else {
              isEu = true;
              comparePrice = comparePrice.replace(",", ".");
            }
          }

          let savePrice = (comparePrice - subscriptionPrice).toFixed(2).toString();
          subscriptionPrice = (subscriptionPrice).toFixed(2);

          if (isEu) {
            subscriptionPrice = subscriptionPrice.toString().replace(".", ",");
            comparePrice = comparePrice.replace(".", ",");
            savePrice = savePrice.replace(".", ",");
          }

          elYouSave.setAttribute('data-subscription-save', savePrice);
          elSavePrice.setAttribute(attrSubPrice, subscriptionPrice);

          consoleLog(["variant", variant, pack, subscriptionPrice, comparePrice]);

          updateOfferText(listPack);
        });

        sortedSellingPlans.forEach((plan) => {
          const planValue = plan.options[0].value.toLowerCase();
          const frequency = planValue.split(" ")[0];
          if (
            planValue.includes("week") ||
            (Number(frequency) && Number(frequency) > 3)
          )
            return;
          const option = document.createElement("option");
          option.setAttribute("data-frequency", frequency);
          option.value = plan.id;
          option.text = plan.name.replace("Delivery e", "E");
          option.text = plan.name.replace("month", "Month");
          $(".rtx-frequency").append(option);
        });
      }
    );
  };

  /**
   * Removes the iCart element
   */
  const removeICart = () => {
    $('body > .icart').remove();
  };

  /**
   * Updates the use case text based on the selected pack and frequency.
   * @param {HTMLElement} listPack - The list pack element.
   */
  const updateUseCase = (listPack) => {
    const vPacks = listPack.getAttribute("data-pack");
    const vValue = listPack.querySelector(".rtx-frequency").value;
    let vFrequency = listPack
      .querySelector(`option[value="${vValue}"]`);

    if (!vFrequency) return;

    vFrequency = vFrequency
      .getAttribute("data-frequency");
    consoleLog(["updateUseCase", vPacks, vFrequency]);

    var vFamilyUseText = "Perfect for everyday usage families with 2 children";
    if (vPacks == 1 || vPacks == 2 || vPacks == 3) {
      if (vFrequency == 1) {
        vFamilyUseText = "Perfect for everyday usage families with 2 children";
      } else if (vFrequency == 2) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      } else if (vFrequency == 3) {
        vFamilyUseText =
          "Perfect for use a few times a week by families with one child";
      }
    } else if (vPacks == 4) {
      if (vFrequency == 1) {
        vFamilyUseText =
          "Perfect for everyday use by families with three children";
      } else if (vFrequency == 2) {
        vFamilyUseText =
          "Perfect for everyday use by families with two or three children";
      } else if (vFrequency == 3) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      }
    }

    listPack.querySelector(".offer_text").innerText = vFamilyUseText;
  };

  /**
   * Updates the offer text based on the selected pack.
   *
   * @param {HTMLElement} listPack - The list pack element.
   */
  const updateOfferText = (listPack) => {
    consoleLog("updateOfferText", listPack);

    const pack = listPack.getAttribute("data-pack");
    const elSavePrice = listPack.querySelector(`.save-price-${pack}`);
    const elSavePercent = listPack.querySelectorAll(`.save-percent-${pack}`);
    const elYouSave = listPack.querySelector(`.you-save-price-${pack}`);
    const attrSavePrice = "data-save-price";

    const regPriceFloat = listPack
      .querySelector(`.reg-price-${pack}`)
      .getAttribute(attrRegPrice);

    if (listPack.querySelector('input[type="checkbox"]').checked) {
      elSavePrice.innerText = elSavePrice.getAttribute(attrSubPrice);
      elSavePercent.forEach((el) => {
        el.innerText = el.getAttribute(attrSubPrice);
      });
      elYouSave.innerText = elYouSave.getAttribute('data-subscription-save');
    } else {
      elSavePrice.innerText = elSavePrice.getAttribute(attrRegPrice);
      elSavePercent.forEach((el) => {
        el.innerText = el.getAttribute(attrRegPrice);
      });
      elYouSave.innerText = elYouSave.getAttribute('data-save');
    }

    if (listPack.querySelector('input[type="checkbox"]').checked) {
      $(listPack).find(".offerBox").slideDown();

      updateUseCase(listPack);
    } else {
      $(listPack).find(".offerBox").slideUp();
    }
  };

  // add event listeners to each list pack
  listPacks.forEach((listPack) => {
    // listener to toggle StayAI
    const billingToggle = listPack
      .querySelector(".billingtoggle");
    if (billingToggle) {
      billingToggle.addEventListener("click", function () {
        updateOfferText(listPack);
      });
    }

    // listener to update use case
    listPack
      .querySelector(".rtx-frequency")
      .addEventListener("change", function () {
        updateUseCase(listPack);
      });

    // listener to ATC
    listPack
      .querySelector(".package_button")
      .addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        listPack.querySelector(".package_button").classList.add("processing");
        addListPackToCart(listPack);
        return false;
      });
  });

  initStayAIData();
}

$(document).ready(function () {
  // initForm();

  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const min = 26;
  const max = 240;

  const randomNumber = getRandomNumber(min, max);

  $(".lp-fp--sold").text(randomNumber);

  $(".lp-tr--learn-more-btn").click(function () {
    $(".lp-tr--scroll-to-learn").fadeIn("slow");

    const sectionHeight = $(".lp-tr--why-kids-love-np-section").outerHeight();

    const sectionOffsetTop = $(".lp-tr--why-kids-love-np-section").offset().top;

    $(window).scroll(function () {
      let scrollTopj = $(window).scrollTop();
      let scrollPoint = sectionOffsetTop + sectionHeight;

      console.log(
        "ScrollTop:",
        Math.floor(scrollTopj),
        "ScrollPoint:",
        Math.floor(scrollPoint)
      );

      if (scrollTopj >= scrollPoint) {
        $(".lp-tr--scroll-to-learn").fadeOut("fast");
      }
    });
  });

  const priceNumEl = $(".overall-price .price-num");
  const priceOffEl = $(".overall-price .price-off");
  const priceCompareEl = $(".compare-price");
  const priceSavedEl = $(".saved-price");
  const defaultPriceEl = $('.packs input[type="radio"]:checked').attr(
    "data-tick-price"
  );

  const addToCart = $("#proceed");
  const currency = addToCart.attr("data-currency");
  priceNumEl.text(defaultPriceEl);

  let packId3 = addToCart.attr("data-default-id");

  let inputId;
  let checkboxId;

  $('.packs input[type="radio"]').change(function () {
    const currentPrice = $(this).attr("data-tick-price");
    const currentId = $(this).attr("data-tick-id");
    const currentPercentOff = $(this).attr("data-percent-off");
    const currentCompare = $(this).attr("data-compare-price");
    const currentSaved = $(this).attr("data-saved-price");
    priceNumEl.text(currentPrice);
    priceOffEl.text(currentPercentOff);
    priceCompareEl.text(currentCompare);
    priceSavedEl.text(currentSaved);

    inputId = currentId;
    if (checkboxId) {
      addToCart.attr(
        "href",
        `/cart/${currentId}:1,${checkboxId}:1?currency=${currency}`
      );
    } else {
      addToCart.attr("href", `/cart/${currentId}:1?currency=${currency}`);
    }
  });

  // ADD PET LOCKET
  $("#petlocket").change(function () {
    console.log(packId3);
    if ($(this).is(":checked")) {
      addToCart.attr("data-add-on", true);
      addToCart.attr("data-petlocket", $(this).val());
      addToCart.attr(
        "href",
        `/cart/${inputId ? inputId : packId3}:1,${$(
          this
        ).val()}:1?currency=${currency}`
      );
      checkboxId = $(this).val();
    } else {
      addToCart.attr("data-add-on", false);
      addToCart.attr("data-petlocket", "");
      addToCart.attr(
        "href",
        `/cart/${inputId ? inputId : packId3}:1?currency=${currency}`
      );
      checkboxId = null;
    }
  });
});


(() => {

  $(document).ready(function(){
    $('.rtx-form-gallery div').each(function(){
    $(this).clone().appendTo('.slider-for--rtx-form-gallery')
  })
 
      $('.slider-for--rtx-form-gallery').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      useTransform: true,
      asNavFor: '.rtx-form-gallery',
      infinite: false,
      });
    $('.rtx-form-gallery').slick({
      slidesToShow: 4.5,
      slidesToScroll: 1,
      asNavFor: '.slider-for--rtx-form-gallery',
      dots: false,
      focusOnSelect: true,
      centerPadding: '30px',
      prevArrow: $('.rtx-form-gallery-prev'),
      nextArrow: $('.rtx-form-gallery-next'),
      infinite: false,
    });

  })

  $('#purchase .magicpatch-packs ul li').on('click', function(){
    const btnID = $(this).attr('data-pack');
    const slideNum = $(`.slider-for--rtx-form-gallery .slick-slide[data-pack-num='${btnID}']`)
    const index = $(`.slider-for--rtx-form-gallery .slick-slide`).index(slideNum)
    $('.slider-for--rtx-form-gallery').slick('slickGoTo', Number(index));
  })
 
})()